module.exports = __webpack_public_path__ + "static/img/trace_tagline.50ef002d.png";